"use strict";

exports.__esModule = true;
var _DeviceSelector = require("./DeviceSelector");
Object.keys(_DeviceSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceSelector[key]) return;
  exports[key] = _DeviceSelector[key];
});